<template>
  <div>
    <CollectionView
      :collection-id="collectionId"
      :collection="collection"
      :searcher="searcher"
      :publications="publications"
      :sort-strategy="sortStrategy"
      :custom-counter="customCounter"
    />
    <AppFooter />
  </div>
</template>

<script>
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('_id.vue');
import CollectionView from '@/components/views/CategoryView/CollectionView.vue';
import AppFooter from '@/components/views/AppFooter/AppFooter.vue';
import pageCommonMixin from '@/components/mixins/pageCommonMixin';
import ManagePublicationsStates from '@/enums/ManagePublicationsStatesEnum';
import publicationUtils from '@/services/utils/publicationUtils';
import AppStateEnum from '@/enums/AppStateEnum';
import SearchPublicationsFactory from '@/classes/factories/SearchPublicationsFactory';

export default {
  name: 'CollectionPage',
  components: {
    CollectionView,
    AppFooter
  },
  mixins: [pageCommonMixin],
  async asyncData(context) {
    logger.info('Start load open params for collection');
    const { route, store } = context;

    const slug = route.params.id;

    if (process.server) {
      store.dispatch('LibraryStore/destroyStates', [
        ManagePublicationsStates.LIBRARY
      ]);
    }
    await store.dispatch('LibraryStore/initState', {
      managePublicationsState: ManagePublicationsStates.LIBRARY
    });
    const collectionId =
      store.getters['LibraryStore/getPublicationIdBySlug'](slug) || slug;
    logger.info(`Get collectionId: ${collectionId}`);

    const collection = store.getters['LibraryStore/getPublicationById'](
      collectionId
    );

    const collectionLanguage = collection?.language;
    let currentLanguage = store.getters['ContextStore/currentLanguageGetter'];
    if (collectionLanguage !== currentLanguage) {
      store.commit('ContextStore/setCurrentLanguage', collectionLanguage);
      currentLanguage = collectionLanguage;
    }
    let newSearcher;
    const prevRoute = store.state.ContextStore.previousRoute;
    if (prevRoute?.name === AppStateEnum.CATEGORY) {
      newSearcher = store.getters['LibraryStore/getCategorySearcher'];
    } else if (
      prevRoute?.name === AppStateEnum.MANAGE_PUBLICATION ||
      prevRoute?.name === AppStateEnum.MANAGE_PUBLICATION_LANGUAGE
    ) {
      newSearcher = store.getters['LibraryStore/getLibrarySearcher'];
    } else {
      newSearcher = store.getters['LibraryStore/getCollectionSearcher'];
    }
    const builder = SearchPublicationsFactory.searcherToBuilder(newSearcher)
      .setState(ManagePublicationsStates.COLLECTION)
      .setCategories([])
      .setCollectionId(collectionId)
      .setLanguage(currentLanguage);

    const searcher = builder.build();
    store.commit('LibraryStore/setCollectionSearcher', searcher);

    const sortStrategy = store.getters['ContextStore/librarySortStrategy'];
    let publications;
    let customCounter;
    if (process.server) {
      publications = store.getters['LibraryStore/searchPublications'](searcher);
      customCounter = publicationUtils.countPublicationItems(publications);
      publications = publicationUtils.sortPublication(
        publications,
        sortStrategy
      );
      publications = publications.slice(0, 15);
      store.commit('LibraryStore/destroyLibrary');
    }
    return {
      collectionId,
      collection,
      searcher,
      publications,
      sortStrategy,
      customCounter
    };
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if (mutation.type === 'ContextStore/setServiceClientInit') {
        this.publications = null;
        this.customCounter = null;
      }
    });
  }
};
</script>

<style lang="less"></style>
